import React from 'react'

export type SpacingType =
  | [number]
  | [number, number]
  | [number, number, number]
  | [number, number, number, number]

export interface SpacingProps {
  p?: number | SpacingType
  m?: number | SpacingType
  mt?: number
  mr?: number
  mb?: number
  ml?: number
  pt?: number
  pr?: number
  pb?: number
  pl?: number
}

export const useSpacingProps = ({
  p,
  m,
  mt,
  mr,
  mb,
  ml,
  pt,
  pr,
  pb,
  pl,
}: SpacingProps): {
  padding: SpacingType
  margin: SpacingType
} =>
  React.useMemo(
    () => ({
      margin: m
        ? typeof m === 'number'
          ? [m]
          : m
        : [mt ?? 0, mr ?? 0, mb ?? 0, ml ?? 0],
      padding: p
        ? typeof p === 'number'
          ? [p]
          : p
        : [pt ?? 0, pr ?? 0, pb ?? 0, pl ?? 0],
    }),
    [m, mt, mr, mb, ml, p, pt, pr, pb, pl],
  )
